// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"50":"enemies","180":"story","543":"equipment","652":"haven","722":"calc","803":"heroName","869":"abyss"}[chunkId] + "." + {"50":"f5d3c494","180":"ffae2cd8","543":"baa5ee54","652":"7827c377","722":"e5ced815","803":"417c2853","869":"1971a026"}[chunkId] + ".css";
};